import { Route, Routes } from "react-router-dom";

//import * as Sentry from "@sentry/react";
//import SentryErrorBoundary from "./helpers/SentryErrorBoundary";

import RequireAuth from "./auth/RequireAuth";

//pages
import Counters from "./pages/";
import CounterScreen from "./pages/CounterScreen";
import Jobs from "./pages/Jobs";
import Forbidden from "./pages/Forbidden";
import Settings from "./pages/Settings";
import OAuthRedirect from "./pages/OAuthRedirect";

// Create Custom Sentry Route component
//onst SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

interface RouteProps {
	setClientSet: (v: boolean) => void;
}

const Router = (props: RouteProps) => {
	const { setClientSet } = props;

	return (
		<Routes>
			<Route path="/oauth-redirect" element={<OAuthRedirect />} />
			<Route path="/Forbidden" element={<Forbidden />} />
			<Route
				path="/counter/:id"
				element={
					<RequireAuth>
						<CounterScreen />
					</RequireAuth>
				}
			/>
			<Route
				path="/jobs/:id"
				element={
					<RequireAuth>
						<Jobs />
					</RequireAuth>
				}
			/>
			<Route
				path="/settings"
				element={
					<RequireAuth>
						<Settings setClientSet={setClientSet} />
					</RequireAuth>
				}
			/>
			<Route
				path="/"
				element={
					<RequireAuth>
						<Counters />
					</RequireAuth>
				}
			/>

			<Route path="*" element={<p>Path not resolved</p>} />
		</Routes>
	);
};

export default Router;
